/* eslint-disable max-len */
import React from "react";
import "../StoragePages.scss";
import PropTypes from "prop-types";
import { Page } from "components/core/Page";
import { StorageHeader } from "components/storages/Header";
import {
	Description,
	ListPoint,
	LastSearchBar,
	BorderLine,
	Heading
} from "components/storages/Common";
import { Paragraph } from "components/core/Typography";
import { RV_STORAGE_DATA } from "components/storages/ContentData/RVStorageData";
import Container from "components/core/Page/Container";
import { ScrollToTop } from "components/core/ScrollToTop";
import { useSelector } from "react-redux";
import { PAGE_SUB_TYPES } from "@sparefoot/tracking-events";
import usePageViewTracking from "hooks/tracking/usePageViewTracking";

const CombinedSection = ({ title, desc }) => (
	<>
		<Paragraph
			className="sf-type sf-heading size-xlarge"
			weight="bold"
		>
			{title}
		</Paragraph>
		<Description desc={desc} />
	</>
);

const RVStoragePage = () => {
	usePageViewTracking(PAGE_SUB_TYPES.RV_LANDING);
	const baseUrl = useSelector((state) => state?.app?.baseUrl);
	return (
		<Page
			className="storage-page"
			pageType={PAGE_SUB_TYPES.RV_LANDING}
			title="RV Storage - Rental Guide & Facility Search | Storage.com"
			description="Need budget-friendly RV storage? Storage.com compares 
		rates & sizes for all types of RVs. Find the perfect fit without breaking 
		the bank!"
			canonical={`${baseUrl}/rv-storage/`}
		>
			<Container>
				<StorageHeader
					heading="Find RV Storage Near You!"
					searchIn="rv"
					level="1"
				/>
				<div className="all-sections">
					{RV_STORAGE_DATA.map((item, index) => (
						<>
							<Heading
								content={item.heading}
								level={item.level}
							/>
							<Description desc={item.description} />
							{item.description2 && (
								<Description desc={item.description2} />
							)}
							{item.subHeadings?.map((subHeading) => (
								<CombinedSection {...subHeading} />
							))}
							<ul>
								{item.points?.map((point) => (
									<ListPoint {...point} />
								))}
							</ul>
							{item.subHeadings2?.map((subHeading) => (
								<CombinedSection {...subHeading} />
							))}
							{item.heading2 && (
								<Paragraph
									className="sf-type sf-heading size-huge"
									weight="bold"
								>
									{item.heading2}
								</Paragraph>
							)}
							{item.description3 && (
								<Description desc={item.description3} />
							)}
							{item.description4 && (
								<Description desc={item.description4} />
							)}
							{index !== RV_STORAGE_DATA.length - 1 && (
								<BorderLine />
							)}
						</>
					))}
					<LastSearchBar />
				</div>
			</Container>
			<ScrollToTop />
		</Page>
	);
};

CombinedSection.propTypes = {
	title: PropTypes.string,
	desc: PropTypes.string
};

export default RVStoragePage;
